exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "input[data-v-a76e93e8] {\n  cursor: pointer;\n  background-color: inherit;\n}\n", ""]);

// exports
